import React from 'react';
import { ComponentFactoryReactContext } from '../components/SitecoreContext';
/**
 * @param {React.ComponentClass<T> | React.SFC<T>} Component
 */
export function withComponentFactory(Component) {
    return function WithComponentFactory(props) {
        return (React.createElement(ComponentFactoryReactContext.Consumer, null, (context) => React.createElement(Component, Object.assign({}, props, { componentFactory: props.componentFactory || context }))));
    };
}
